export default "__VITE_ASSET__05t7GOcO__"